import * as React from 'react';
import styled from 'styled-components';
import { Skeleton } from '../skeleton/Skeleton';
import { VisuallyHidden } from '../../NewGeneralLedger.styles';

const Container = styled.div`
  display: grid;
  gap: 10px;
  padding: 0 24px;
  margin-top: 16px;
`;

const LedgerSidebarBlock = () => (
  <>
    <Skeleton width={50} height={20} />
    <Skeleton height={20} />
    <Skeleton height={20} />
    <Skeleton height={20} />
    <Skeleton height={20} />
    <Skeleton height={20} />
    <Skeleton height={20} />
    <Skeleton height={20} />
    <Skeleton height={20} />
    <Skeleton height={20} />
    <Skeleton height={20} />
  </>
);

export const LedgerSidebarSkeleton = (): React.ReactElement => (
  <Container>
    <LedgerSidebarBlock />
    <LedgerSidebarBlock />
    <LedgerSidebarBlock />
    <LedgerSidebarBlock />
    <VisuallyHidden>Loading</VisuallyHidden>
  </Container>
);
